export enum TemperatureBySensorListColumn {
  Label = 'label',
  SensorID = 'sensorBLEId',
}
